var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "error-container",
    { attrs: { error: _vm.erreur, warning: _vm.warning } },
    [
      _c(
        "div",
        {
          staticClass: "form animated fadeIn p-0",
          class: {
            "container-layout": _vm.$screen.width >= 992,
            "container-mobile": _vm.$screen.width < 992,
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "12", md: "12", lg: "12", xl: "12" } },
                [
                  _c(
                    "h1",
                    {
                      staticClass: "px-0",
                      class: [
                        `${
                          !_vm.$screen.sm && !_vm.$screen.md
                            ? "main-page-title"
                            : ""
                        }`,
                        { "is-pwa": _vm.$isPwa() },
                      ],
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.FormMSG(215, "Purchase Order Details")) +
                          "\n\t\t\t\t"
                      ),
                    ]
                  ),
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-row",
                        {
                          staticClass:
                            "back-with-title cursor-pointer d-flex align-items-center pb-2 pl-0",
                          class: { "mt-16": _vm.$isPwa() },
                        },
                        [
                          _c("b-col", { attrs: { cols: "9" } }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn-transparent",
                                on: { click: _vm.handleClickBack },
                              },
                              [
                                _c(_vm.getLucideIcon("ArrowLeft"), {
                                  tag: "component",
                                  staticClass: "icon",
                                  attrs: {
                                    color: "rgba(6, 38, 62, 0.65)",
                                    size: 22,
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "title-back-bolder mx-0" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.caption1) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "wrap-status d-flex justify-content-end pr-3",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    class: `status ${_vm.classStatus(
                                      _vm.curPo.validated
                                    )}`,
                                    staticStyle: {
                                      "font-size": "0.825rem",
                                      border:
                                        "0.005rem solid rgba(226, 230, 235, 0.65)",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.curPo.validatedStatus) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-card-text",
                        { staticClass: "px-3 pt-4" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "px-3",
                                  attrs: { cols: "12", xl: "12" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card card-border-blue-light",
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: _vm.FormMSG(
                                                      98,
                                                      "PO Reference"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      value:
                                                        _vm.curPo.poReference,
                                                      disabled: "",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-col",
                                            { attrs: { md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: _vm.FormMSG(
                                                      58,
                                                      "Request date"
                                                    ),
                                                    "label-for": "spent",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "b-input-group",
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          disabled: "",
                                                          type: "text",
                                                          id: "spent",
                                                        },
                                                        model: {
                                                          value: _vm.curPo.date,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.curPo,
                                                              "date",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "curPo.date",
                                                        },
                                                      }),
                                                      _c(
                                                        "b-input-group-append",
                                                        [
                                                          _c(
                                                            "b-input-group-text",
                                                            [
                                                              _c("calendar", {
                                                                attrs: {
                                                                  color:
                                                                    "#06263E",
                                                                  opacity:
                                                                    "0.85",
                                                                  width: "15",
                                                                  height: "15",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-col",
                                            { attrs: { md: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: this.getLabel1,
                                                    "label-for": "spent",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "b-input-group",
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          disabled: "",
                                                          type: "number",
                                                          id: "spent",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.curPo
                                                              .amountTotal,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.curPo,
                                                              "amountTotal",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "curPo.amountTotal",
                                                        },
                                                      }),
                                                      _c(
                                                        "b-input-group-append",
                                                        [
                                                          _c(
                                                            "b-input-group-text",
                                                            [
                                                              _c(
                                                                "currency-svg",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "#06263E",
                                                                    opacity:
                                                                      "0.85",
                                                                    width: "15",
                                                                    height:
                                                                      "15",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm.curPo.images &&
                                          _vm.curPo.images.length > 0
                                            ? _c(
                                                "b-col",
                                                {
                                                  staticClass: "pt-28",
                                                  attrs: { md: "3" },
                                                },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        block: "",
                                                        variant:
                                                          "outline-success",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.showPicture(
                                                            _vm.curPo.images
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        _vm.getLucideIcon(
                                                          "Image"
                                                        ),
                                                        {
                                                          tag: "component",
                                                          attrs: { size: 16 },
                                                        }
                                                      ),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            `${_vm.FormMSG(
                                                              78,
                                                              "View"
                                                            )} ${
                                                              _vm.curPo.images
                                                                .length
                                                            } ${_vm.FormMSG(
                                                              79,
                                                              "pictures"
                                                            )}`
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card card-border-blue-light mt-3",
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _vm.$screen.width < 992
                                                ? _c("CardListBuilder", {
                                                    attrs: {
                                                      items: _vm.poDetails,
                                                      fields: _vm.poItemFields,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm.$screen.width >= 992
                                                ? _c("b-table", {
                                                    staticStyle: {
                                                      "text-align": "center",
                                                    },
                                                    attrs: {
                                                      hover: true,
                                                      responsive: "sm",
                                                      items: _vm.poDetails,
                                                      fields: _vm.poItemFields,
                                                      "sticky-header": "700px",
                                                      "head-variant": _vm.hv,
                                                      bordered: "",
                                                      small: "",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-row",
                                        {
                                          staticClass: "justify-content-around",
                                          class: `${
                                            _vm.$screen.width <= 576
                                              ? "footer-fixed"
                                              : ""
                                          }`,
                                        },
                                        [
                                          _vm.canEditPo
                                            ? _c(
                                                "b-col",
                                                {
                                                  attrs: { md: "3", sm: "12" },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "w-100 d-flex justify-content-center align-items-center",
                                                    },
                                                    [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center w-100",
                                                          class: `${
                                                            _vm.$screen.width <=
                                                            576
                                                              ? "mb-2"
                                                              : ""
                                                          }`,
                                                          attrs: {
                                                            variant:
                                                              "outline-primary",
                                                            block: "",
                                                            size: "md",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.handleClickEditPO,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            _vm.getLucideIcon(
                                                              _vm.ICONS.EDIT
                                                                .name
                                                            ),
                                                            {
                                                              tag: "component",
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                size: 20,
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-top":
                                                                  "2px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.FormMSG(
                                                                    168,
                                                                    "Edit Purchase Order"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "b-col",
                                            { attrs: { md: "3", sm: "12" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "w-100 d-flex justify-content-center align-items-center",
                                                },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center align-items-center w-100",
                                                      class: `${
                                                        _vm.$screen.width <= 576
                                                          ? "mb-2"
                                                          : ""
                                                      }`,
                                                      attrs: {
                                                        variant:
                                                          "outline-primary",
                                                        block: "",
                                                        size: "md",
                                                      },
                                                      on: {
                                                        click: _vm.downloadXls,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        _vm.getLucideIcon(
                                                          _vm.ICONS.DOWNLOAD
                                                            .name
                                                        ),
                                                        {
                                                          tag: "component",
                                                          staticClass: "mr-2",
                                                          attrs: { size: 20 },
                                                        }
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "margin-top": "2px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.FormMSG(
                                                                222,
                                                                "Download this Purchase Order"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "b-col",
                                            { attrs: { md: "3", sm: "12" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "w-100 d-flex justify-content-center align-items-center",
                                                },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center align-items-center w-100",
                                                      class: `${
                                                        _vm.$screen.width <= 576
                                                          ? "mb-2"
                                                          : ""
                                                      }`,
                                                      attrs: {
                                                        variant:
                                                          "outline-primary",
                                                        block: "",
                                                        size: "md",
                                                        disabled:
                                                          _vm.isLoadingSendMail,
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.sendXlsByEmail,
                                                      },
                                                    },
                                                    [
                                                      _c("b-spinner", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.isLoadingSendMail,
                                                            expression:
                                                              "isLoadingSendMail",
                                                          },
                                                        ],
                                                        staticClass: "mr-2",
                                                        staticStyle: {
                                                          color:
                                                            "rgba(205, 154, 22, 1)",
                                                        },
                                                        attrs: { small: "" },
                                                      }),
                                                      _c(
                                                        _vm.getLucideIcon(
                                                          _vm.ICONS.SEND.name
                                                        ),
                                                        {
                                                          tag: "component",
                                                          staticClass: "mr-2",
                                                          attrs: { size: 20 },
                                                        }
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "margin-top": "2px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.FormMSG(
                                                                500,
                                                                "Send me this purchace order by Email"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm.canDeleteExpensesOrPO
                                            ? _c(
                                                "b-col",
                                                {
                                                  attrs: { md: "3", sm: "12" },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "w-100 d-flex justify-content-center align-items-center",
                                                    },
                                                    [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center w-100",
                                                          class: `${
                                                            _vm.$screen.width <=
                                                            576
                                                              ? "mb-2"
                                                              : ""
                                                          }`,
                                                          attrs: {
                                                            variant:
                                                              "outline-danger",
                                                            block: "",
                                                            size: "md",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.showDeleteWarning = true
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            _vm.getLucideIcon(
                                                              "Trash"
                                                            ),
                                                            {
                                                              tag: "component",
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                size: 20,
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-top":
                                                                  "2px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.FormMSG(
                                                                    333,
                                                                    "Delete PO"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("PoService", {
                        attrs: {
                          "edit-data": _vm.poSelected,
                          "for-screen-validation": "",
                        },
                        on: {
                          closed: _vm.handlePOServiceClosed,
                          submitted: _vm.handlePOServiceSubmitted,
                          refresh: _vm.handlePOServiceRefresh,
                        },
                        model: {
                          value: _vm.showPoService,
                          callback: function ($$v) {
                            _vm.showPoService = $$v
                          },
                          expression: "showPoService",
                        },
                      }),
                      _c("script-export-modal", {
                        attrs: {
                          items: _vm.scripts,
                          custom: _vm.customReport,
                          "export-type": "po",
                        },
                        on: {
                          "script-export-modal:loading": _vm.handleMailSent,
                          "script-export-modal:closed": _vm.poRerpotOnClosed,
                        },
                        model: {
                          value: _vm.isScriptPoReportOpen,
                          callback: function ($$v) {
                            _vm.isScriptPoReportOpen = $$v
                          },
                          expression: "isScriptPoReportOpen",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          staticClass: "modal-success",
          attrs: {
            "header-class": "header-class-modal-doc-package",
            title: _vm.FormMSG(21211, "Success!"),
            "ok-variant": "success",
            "ok-only": "",
          },
          on: {
            ok: function ($event) {
              _vm.successModal = false
            },
          },
          model: {
            value: _vm.successModal,
            callback: function ($$v) {
              _vm.successModal = $$v
            },
            expression: "successModal",
          },
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.FormMSG(
                  601,
                  "The purchace order has been sent to your Email address"
                )
              ) +
              "\n\t"
          ),
        ]
      ),
      _c("common-warning-on-delete", {
        attrs: { message: _vm.messageOnDeletePo },
        on: {
          "dialog:cancel": function ($event) {
            _vm.showDeleteWarning = false
          },
          "dialog:confirm": _vm.deletePoItem,
        },
        model: {
          value: _vm.showDeleteWarning,
          callback: function ($$v) {
            _vm.showDeleteWarning = $$v
          },
          expression: "showDeleteWarning",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }